export enum TitleType {
  Submit = 'submit',
  OnlyTitle = 'onlyTitle',
  TitleAndBack = 'titleAndBack'
}
